
<template>

	<mymodal ref="modal" title="Отображение ценообразующих факторов" ok="Применить" :reset="reset" :check="check" :submit="submit" :vheight="0.5">
		<b-form-input v-model="attr_name" v-on:input="search" placeholder="Поиск"/>
		
		<b-form-checkbox
		v-model="someSelected"
		:indeterminate="indeterminate"
		aria-describedby="attrs"
		aria-controls="attrs"
		@change="toggleAll"
		>
			Выбрать все
		</b-form-checkbox>

		<div class="main-container_content mt-2">
				
			<b-form-checkbox-group :options="attrs_visible" text-field="name" value-field="id" v-model="selected" stacked v-on:change="update"/>

		</div>

	</mymodal>

</template>

<script>

import api from "../../../../api"
import attrs from "../../../../api/attrs"
import mymodal from "../../../widgets/modal"

export default
{
	components :
	{
		mymodal,
	},

	props :
	{
		keys_if_all_attrs_hidden : { type : Array, default : () => [ "attrs.CadastralNumber", "attrs.Name" ] },
	},

	data()
	{
		return {
			
			selected : [],
			attrs : [],
			attrs_visible : [],
			attr_name : null,
			parent : null,
			someSelected: true,
			indeterminate: false

		}
	},

	methods :
	{
		toggleAll(checked)
		{
		checked ? this.check_all() : this.clear_checked()
		},

		check()
		{
			return true
		},

		reset()
		{
			this.selected = []
			this.attrs = []
			this.attrs_visible = []
			this.attr_name = null
			this.parent = null,
			this.someSelected = true,
			this.indeterminate = false
		},

		update(value)
		{
			var selected = new Set(value)
			var attrs_visible = this.attrs_visible

			this.selected = value

			attrs_visible.forEach(attr => { attr.checked = selected.has(attr.id) })
			this.sort_current_attrs_visible()

			this.attrs_visible = attrs_visible
		},

		sort_current_attrs_visible()
		{
			this.attrs_visible = this.attrs_visible.sort(
				( a, b ) =>
				{
					if(a.checked && ! b.checked) return -1
					else if(! a.checked && b.checked) return 1
					else if(a.name > b.name) return 1
					else if(a.name < b.name) return -1

					return 0
				})
		},

		clear_checked()
		{
			var selected = this.selected

			this.attrs_visible.forEach(
				attr =>
				{
					const ind = selected.findIndex(id => id == attr.id)

					if(ind >= 0)
						selected.splice(ind, 1)
				})

			this.update(selected)
		},

		check_all()
		{
			var selected = this.selected

			this.attrs_visible.forEach(attr => selected.push(attr.id))
			this.update(selected)
		},

		execute(parent)
		{
			this.$refs.modal.execute()

			this.parent = parent

			this.parent.attrs.forEach(
				attr =>
				{
					this.attrs.push(attr)

					if(this.parent.attrs_visible.find(attr_visible => attr_visible.key == attr.key))
						this.selected.push(attr.id)
				})

			this.attrs = api.sort_objects_array_by_key(this.attrs, "name")
			this.attrs_visible = this.attrs
			this.update(this.selected)
		},

		submit()
		{
			var selected
			let reset_attrs

			if(this.selected.length)
			{
				selected = new Set(this.selected)
				reset_attrs = false
			}
			else
			{
				selected = new Set

				this.parent.attrs.forEach(
					attr =>
					{
						if(this.keys_if_all_attrs_hidden.includes(attr.key))
							selected.add(attr.id)
					}
				)
				reset_attrs = true
			}

			var attrs_visible = this.parent.attrs.filter(attr => selected.has(attr.id))
			var prepared_attrs_visible = []

			this.parent.attrs_visible.forEach(
				attr =>
				{
					const ind = attrs_visible.findIndex(attr_visible => attr_visible.key == attr.key)

					if(ind >= 0)
					{
						prepared_attrs_visible.push(attr)
						attrs_visible.splice(ind, 1)
					}
				})

			attrs_visible.forEach(attr => prepared_attrs_visible.push(attr))
			this.parent.attrs_visible = prepared_attrs_visible

			if (reset_attrs)
			{
				this.parent.reset_table_width()
				this.parent.attrs_visible = attrs.sort_attrs_by_keys(this.parent.attrs_visible, this.keys_if_all_attrs_hidden)
			}
			else
			{
				attrs.move_cadastral_number_on_top(this.parent.attrs_visible)
			}
			this.parent.save_to_storage()

			this.$nextTick(
				() =>
				{
					this.parent.set_resizable_and_width()
					this.parent.save_to_storage()
					this.$bvModal.hide(this.id, "modal-prevent-closing")
				})
		},

		search(name)
		{
			if(name == null)
				name = this.attr_name

			const exp = new RegExp(name, "i")

			this.attrs_visible = this.attrs.filter(elem => ( elem.name.match(exp) || name == null ))
			this.sort_current_attrs_visible()
		},
	},
	watch: 
	{
		selected()
		{			
		if (this.selected.length === 0)
			{
			this.indeterminate = false
			this.someSelected = false
		} 
			else if (this.selected.length >= this.attrs.length)
			{
			this.indeterminate = false
			this.someSelected = true
		} 
			else 
			{
			this.indeterminate = true
			this.someSelected = true
		}
		}
	}
}

</script>

